// extracted by mini-css-extract-plugin
export var content = "Footer-module--content--c4da4";
export var copyright = "Footer-module--copyright--c121d";
export var footer = "Footer-module--footer--f9074";
export var hours = "Footer-module--hours--e9872";
export var infoColumn = "Footer-module--infoColumn--7d782";
export var infoItem = "Footer-module--infoItem--432a6";
export var linkColumns = "Footer-module--linkColumns--e063e";
export var links = "Footer-module--links--bdf4f";
export var logo = "Footer-module--logo--03154";
export var socialColumn = "Footer-module--socialColumn--daa3c";